import { Spinner, Box } from '@cast/design-system';

export const TrialLoadingSpinner = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
      <Spinner size={40} />
    </Box>
  );
};
